import Tabs from '@/components/Tabs/Tabs';
import './Project.less';
import { useEffect, useState } from 'react';
import projectIcon from '@/assets/project/project.png';
import { Spin, Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';

export default function Home() {
  const [list, setList] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [type, setType] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    query();
  }, []);

  const query = async () => {
    const res = await projectController.list({
      pageIndex: pageIndex,
      pageSize: pageSize,
      type: type,
    });
    if (res.code == 0) {
      setLoading(false);
      setList(res.data.records);
    }
  };

  const clickProject = (item) => {
    if (item.type === 0) {
      window.location.href =
        window.location.protocol + '//' + window.location.host + '/texture/' + item.id;
    }
  };

  return (
    <div className="project-home">
      <div className="project">Project</div>
      <Spin style={{ backgroundColor: 'rgb(27,27,27)', marginTop: 20 }} spinning={loading}></Spin>
      <div className="list">
        {list.map((item) => {
          return (
            <div
              key={item.id}
              className="item"
              onClick={() => {
                clickProject(item);
              }}>
              <img className="project-img" src={projectIcon}></img>
            </div>
          );
        })}
      </div>
    </div>
  );
}
